import React, { Component } from 'react'

export default class propertyCityList extends Component {
    render() {
        return (
                <section class="section-category-tags">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="category-tags-panel">
                                <div class="row">
                                    <div class="col-12">
                                        <ol class="breadcrumb breadcrumb-alt">
                                            <li class="breadcrumb-item"><a href="#">UAE</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Dubai</li>
                                        </ol>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-6">
                                        <ul>
                                            <li><a href="#">Academic City<span>(35)</span></a></li>
                                            <li><a href="#">Al Awir<span>(2)</span></a></li>
                                            <li><a href="#">Al Badaa<span>(52)</span></a></li>
                                            <li><a href="#">Al Barari<span>(31)</span></a></li>
                                            <li><a href="#">Al Barsha<span>(1,268)</span></a></li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-3 col-6">
                                        <ul>
                                            <li><a href="#">Al Buteen<span>(1)</span></a></li>
                                            <li><a href="#">Al Furjan<span>(565)</span></a></li>
                                            <li><a href="#">Al Garhoud<span>(102) </span></a></li>
                                            <li><a href="#">Al Hudaiba<span>(58)</span></a></li>
                                            <li><a href="#">Al Jaddaf<span>(389)</span></a></li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-3 col-6">
                                        <ul>
                                            <li><a href="#">Al Jafiliya<span>(14)</span></a></li>
                                            <li><a href="#">Al Karama<span>(509)</span></a></li>
                                            <li><a href="#">Al Mamzar<span>(137)</span></a></li>
                                            <li><a href="#">Al Mina<span>(102)</span></a></li>
                                            <li><a href="#">Al Nahda<span>(Dubai)(1,010)</span></a></li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-3 col-6">
                                        <ul>
                                            <li><a href="#">Al Quoz<span>(221)</span></a></li>
                                            <li><a href="#">Al Qusais<span>(827)</span></a></li>
                                            <li><a href="#">Al Rashidiya<span>(21)</span></a></li>
                                            <li><a href="#">Al Safa<span>(43)</span></a></li>
                                            <li><a href="#">Al Satwa<span>(241)</span></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-center mt-3 mt-md-4">
                                        <a href="#" class="btn btn-link p-1">Show More <i class="fa fa-angle-down ml-2" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        )
    }
}
